import React from 'react'
import { getMessage } from '../../../utils/index'

import './WebhookPixAutomaticoForm.scss'
import LtsInputText from '../../../components/lottus/lts-input-text'
import LtsLookupConfiguracaoPixAutomatico from '../../../components/lottus/lts-lookup-configuracao-pixautomatico'
import { Checkbox } from 'primereact/checkbox'
import { Dropdown } from 'primereact/dropdown'
import { Button } from 'primereact/button'
import _ from 'lodash'

const tiposWebhook = [
  { label: 'Recorrência (REC)', value: 'REC' },
  { label: 'Cobrança (COBR)', value: 'COBR' },
]

export const WebhookPixAutomaticoForm = (props) => {
  const record = props.record
  const messages = props.messages
  const loadingCadastrar = props.loadingCadastrar
  const loadingConsultar = props.loadingConsultar
  const loadingCancelar = props.loadingCancelar
  const pspResponse = props.pspResponse
  const isExistingRecord = !!record.oid

  const getStatusBadgeClass = () => {
    const status = record.status
    if (status === 'ATIVO') return 'status-badge status-ativo'
    if (status === 'ERRO') return 'status-badge status-erro'
    if (status === 'INATIVO') return 'status-badge status-inativo'
    return 'status-badge status-pendente'
  }

  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12">
        <div className="card card-w-title webhook-pix-automatico-form">
          <h3>
            {getMessage(messages, 'webhookpixautomatico.label.webhookpixautomatico')} {record.oid || ''}
          </h3>

          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-10 p-md-8 p-lg-8 p-xl-6">
              <LtsInputText
                value={record.descricao}
                onChange={(e) => props.onChangeDescricao(e)}
                name="descricao"
                autoFocus={true}
                maxLength={255}
                label={getMessage(messages, 'webhookpixautomatico.label.descricao')}
              />
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-10 p-md-8 p-lg-8 p-xl-6">
              <LtsLookupConfiguracaoPixAutomatico
                label={getMessage(messages, 'webhookpixautomatico.label.configuracaopixautomatico')}
                value={_.get(record, 'configuracaoPixAutomatico.value', '')}
                oidRecord={_.get(record, 'configuracaoPixAutomatico.id', '')}
                history={props.history}
                onChange={(e) => props.setConfiguracaoPixAutomatico(e)}
              />
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-10 p-md-8 p-lg-8 p-xl-6">
              <label htmlFor="tipo">{getMessage(messages, 'webhookpixautomatico.label.tipo')}</label>
              <Dropdown
                id="tipo"
                value={record.tipo}
                options={tiposWebhook}
                onChange={(e) => props.onChangeTipo(e)}
                placeholder="Selecione o tipo"
                disabled={isExistingRecord}
              />
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-6 p-sm-8 p-md-6 p-lg-4 p-xl-2">
              <Checkbox
                checked={record.ativo}
                onChange={(e) => props.onChangeField('ativo', e)}
                name="ativo"
                style={{ marginRight: '5px' }}
              />
              <label htmlFor="chkativo" className="label">
                {getMessage(messages, 'webhookpixautomatico.label.ativo')}
              </label>
            </div>
          </div>

          {isExistingRecord && (
            <>
              <div className="p-grid form-group">
                <div className="p-col-12 p-sm-10 p-md-8 p-lg-8 p-xl-6">
                  <label>{getMessage(messages, 'webhookpixautomatico.label.status')}</label>
                  <div style={{ marginTop: '0.5rem' }}>
                    <span className={getStatusBadgeClass()}>{record.statusDescricao || 'Pendente'}</span>
                  </div>
                </div>
              </div>

              {record.webhookUrl && (
                <div className="p-grid form-group">
                  <div className="p-col-12 p-sm-10 p-md-8 p-lg-8 p-xl-6 url-field">
                    <label>{getMessage(messages, 'webhookpixautomatico.label.webhookurl')}</label>
                    <div className="p-inputgroup">
                      <LtsInputText value={record.webhookUrl} name="webhookUrl" disabled={true} />
                      <Button
                        icon="pi pi-copy"
                        className="p-button-secondary copy-button"
                        onClick={() => props.copyToClipboard(record.webhookUrl)}
                        title="Copiar URL"
                      />
                    </div>
                    <small>{getMessage(messages, 'webhookpixautomatico.label.webhookurl.help')}</small>
                  </div>
                </div>
              )}

              {record.mensagemErro && (
                <div className="p-grid form-group">
                  <div className="p-col-12 p-sm-10 p-md-8 p-lg-8 p-xl-6">
                    <label style={{ color: '#c63737' }}>
                      {getMessage(messages, 'webhookpixautomatico.label.mensagemerro')}
                    </label>
                    <div className="response-panel error">{record.mensagemErro}</div>
                  </div>
                </div>
              )}

              <div className="p-grid form-group psp-actions">
                <div className="p-col-12 p-sm-10 p-md-8 p-lg-8 p-xl-6">
                  <label>{getMessage(messages, 'webhookpixautomatico.label.acoespsp')}</label>
                  <div className="p-grid" style={{ marginTop: '0.5rem' }}>
                    <div className="p-col-12 p-sm-4">
                      <Button
                        label={getMessage(messages, 'webhookpixautomatico.label.cadastrarnopsp')}
                        icon="pi pi-cloud-upload"
                        className="p-button-success p-d-block"
                        onClick={props.onCadastrarNoPsp}
                        loading={loadingCadastrar}
                        disabled={loadingCadastrar || loadingConsultar || loadingCancelar || record.status === 'ATIVO'}
                      />
                    </div>
                    <div className="p-col-12 p-sm-4">
                      <Button
                        label={getMessage(messages, 'webhookpixautomatico.label.consultarnopsp')}
                        icon="pi pi-search"
                        className="p-button-info p-d-block"
                        onClick={props.onConsultarNoPsp}
                        loading={loadingConsultar}
                        disabled={loadingCadastrar || loadingConsultar || loadingCancelar}
                      />
                    </div>
                    <div className="p-col-12 p-sm-4">
                      <Button
                        label={getMessage(messages, 'webhookpixautomatico.label.cancelarnopsp')}
                        icon="pi pi-times"
                        className="p-button-danger p-d-block"
                        onClick={props.onCancelarNoPsp}
                        loading={loadingCancelar}
                        disabled={loadingCadastrar || loadingConsultar || loadingCancelar || record.status !== 'ATIVO'}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {pspResponse && (
                <div className="p-grid form-group">
                  <div className="p-col-12 p-sm-10 p-md-8 p-lg-8 p-xl-6">
                    <div className={`response-panel ${pspResponse.success ? 'success' : 'error'}`}>
                      <strong>{pspResponse.success ? 'Sucesso' : 'Erro'}:</strong> {pspResponse.message}
                      {pspResponse.data && (
                        <pre style={{ marginTop: '0.5rem', whiteSpace: 'pre-wrap' }}>
                          {JSON.stringify(pspResponse.data, null, 2)}
                        </pre>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}
